import React, { useEffect, useState } from "react";
import "./BalanceDiario.css";

export default function BalanceDiario({ onClose, turnos, profSel }) {
  const [total, setTotal] = useState(0);
  const [turnosPagados, setTurnosPagados] = useState([]);

  useEffect(() => {
    if (!turnos || turnos.length === 0) return;

    const hoy = new Date().toISOString().split("T")[0];

    const filtrados = turnos.filter((t) => {
      const fechaTurno = t.start
        ? new Date(t.start).toISOString().split("T")[0]
        : null;
      const coincideFecha = fechaTurno === hoy;
      const estaPagado = Boolean(t.pagado);
      const tieneMonto = parseFloat(t.monto || 0) > 0;
      const coincideProf =
        !profSel || profSel === "Todos"
          ? true
          : String(t.profesional_id) === String(profSel);

      return coincideFecha && estaPagado && tieneMonto && coincideProf;
    });

    setTurnosPagados(filtrados);
    const totalHoy = filtrados.reduce(
      (sum, t) => sum + parseFloat(t.monto || 0),
      0
    );
    setTotal(totalHoy);
  }, [turnos, profSel]);

  const fechaHoy = new Date().toLocaleDateString("es-AR", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="balance-modal">
      <div className="balance-contenido">
        <div className="balance-header">
          <h2 className="balance-titulo">Balance Diario</h2>
          <button className="balance-cerrar-x" onClick={onClose} aria-label="Cerrar">
            ✕
          </button>
        </div>

        <p className="balance-fecha">{fechaHoy}</p>

        <div className="balance-total-box">
          <span className="balance-total-label">Total cobrado hoy</span>
          <span className="balance-total-monto">${total.toLocaleString("es-AR", { minimumFractionDigits: 2 })}</span>
        </div>

        <div className="balance-lista">
          {turnosPagados.length > 0 ? (
            turnosPagados.map((t, i) => (
              <div key={i} className="balance-item">
                <div className="balance-item-info">
                  <span className="balance-item-nombre">{t.paciente || "Paciente sin nombre"}</span>
                  {t.title && (
                    <span className="balance-item-motivo">{t.title}</span>
                  )}
                  {t.profesional && (
                    <span className="balance-item-prof">{t.profesional}</span>
                  )}
                </div>
                <span className="balance-item-monto">
                  ${parseFloat(t.monto || 0).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
                </span>
              </div>
            ))
          ) : (
            <p className="balance-vacio">No hay pagos registrados hoy.</p>
          )}
        </div>

        <button className="balance-cerrar-btn" onClick={onClose}>
          Cerrar
        </button>
      </div>
    </div>
  );
}
